import { createAction, props } from '@ngrx/store';
import { Sunbed, SunbedForm, Zone } from '@shared-models';

const actionPrefix = '[SUNBEDS]';

export const sunbedPrereservationAction = createAction(
  `${actionPrefix} Sunbed PreReservation`,
  props<{ zone: Zone; formData: SunbedForm; zoneIndex: number }>(),
);

export const addSunbedToCartAction = createAction(
  `${actionPrefix} Add Sunbed To Cart`,
  props<{ sunbed: Sunbed }>(),
);

export const removeSunbedFromCartAction = createAction(
  `${actionPrefix} Remove Sunbed From Cart`,
  props<{ sunbed: Sunbed }>(),
);

export const showSunbedCartAction = createAction(
  `${actionPrefix} Show Sunbed Cart`,
  props<{ display: boolean }>(),
);

export const setEnabledReservationsAction = createAction(
  `${actionPrefix} Set Enabled Reservations`,
  props<{ enabled: boolean }>(),
);
